import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 15vh;
  margin: 0 15.625%;
  margin-top: 1vh;

  @media (max-width: 960px) {
    flex-direction: column;
    text-align: center;
    margin: 0 25px;
  }
`;

export const InvilliaContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  > * + * {
    margin-left: 1rem;
  }

  @media (max-width: 960px) {
    flex-direction: column;

    > * + * {
      margin-left: 0;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 960px) {
    margin: 0 20px;

  }
`;

export const InvilliaApps = styled.img`
  width: auto;

  @media (max-width: 1024px) {
    width: 40%;
  }

  @media (max-width: 960px) {
    width: 45%;
  }
`;

export const Year = styled.span`
  color: #ffffff;
  font-size: 1.37rem;
  margin: 0.2rem 0 0 0.5rem;

  @media (max-width: 1024px) {
    font-size: 3rem;
    margin-left: 0.5rem;
  }

  @media (max-width: 960px) {
    font-size: 1rem;
    margin-left: 0.5rem;
  }
`;

export const FooterText = styled.p`
  color: #ffffff;
  opacity: 0.6;
  font-size: 1.125rem;
  font-weight: 400;

  @media (max-width: 1024px) {
    font-size: 3rem;
    margin-bottom: 3%;
  }

  @media (max-width: 960px) {
    font-size: 1rem;
    margin-bottom: 5%;
  }
`;

export const MadeBy = styled.p`
  font-size: 1.12rem;
  color: #ffffff;
  font-weight: 500;
  margin-right: 0.5rem;
  padding: 0.5rem;

  @media (max-width: 1024px) {
    display: none;
  }

  @media (max-width: 960px) {
    display: none;
  }
`;

export const InvilliaLogo = styled.img`
  width: auto;

  @media (max-width: 1024px) {
    display: none;
  }
  @media (max-width: 960px) {
    display: none;
  }
`;

export const RightsReserved = styled.div``;

export const RightsReservedText = styled.p`
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 500;
`;

export const RightsReservedLinks = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 960px) {
    justify-content: center;
    padding: .5rem 0;
  }
`;

export const RightsReservedSeparator = styled.p`
  color: #6a6681;
  font-size: 0.875rem;
  font-weight: 400;
  margin-left: 4px;
  margin-right: 4px;
`;

export const RightsReservedLink = styled.a`
  color: #6a6681;
  font-size: 0.875rem;
  font-weight: 400;
`;
